import {
  AppstoreAddOutlined,
  DollarCircleOutlined,
  PieChartOutlined,
  ShoppingCartOutlined,
  TagsOutlined,
} from '@ant-design/icons'
import { Card, List, Spin } from 'antd'
import { useMemo } from 'react'

import { usePTOContext } from 'context/pto-context-provider'
import { formatNumber } from 'utils/formatted-number'

const Overview = () => {
  const { loading, data } = usePTOContext()

  const detail = useMemo(() => {
    return [
      {
        title: 'Funding target (USDC)',
        value: formatNumber(data?.fundingTarget, 3),
        icon: (
          <DollarCircleOutlined
            className="icons-style"
            style={{ background: 'lightgreen', color: 'green' }}
          />
        ),
      },
      {
        title: 'NFTs Issued',
        value: data?.maxNFTSupply,
        icon: (
          <AppstoreAddOutlined
            className="icons-style"
            style={{ background: 'lightblue', color: 'blue' }}
          />
        ),
      },
      {
        title: 'Total NFTs Purchased',
        value: data?.totalNFTsPurchase,
        icon: (
          <ShoppingCartOutlined
            className="icons-style"
            style={{ background: 'lightcoral', color: 'red' }}
          />
        ),
      },
      {
        title: 'Total Claimed NFTs',
        value: data?.totalNFTsClaim,
        icon: (
          <TagsOutlined
            className="icons-style"
            style={{ background: 'lightyellow', color: 'goldenrod' }}
          />
        ),
      },
      {
        title: 'Price per NFT (USDC)',
        value: formatNumber(data?.pricePerNFT, 3),
        icon: (
          <DollarCircleOutlined
            className="icons-style"
            style={{ background: 'lightgreen', color: 'darkgreen' }}
          />
        ),
      },
      {
        value: (
          <>
            Sold&nbsp;
            <span>{data?.percent?.toFixed(2)}%</span>
          </>
        ),
        icon: (
          <PieChartOutlined
            className="icons-style"
            style={
              data.totalNFTsPurchase === data.maxNFTSupply
                ? { background: 'lightgreen', color: 'darkgreen' }
                : { background: 'lightyellow', color: 'orange' }
            }
          />
        ),
      },
    ]
  }, [data])

  return (
    <List
      grid={{ gutter: 16, column: 4 }}
      dataSource={detail}
      className="detail-card"
      renderItem={(item, index) => (
        <>
          <List.Item key={index}>
            {
              <Card className={'card-style'}>
                <div className={'content-style'}>
                  <div>{item.icon}</div>
                  {!loading ? (
                    <div>
                      <div className={'title-style'}>{item.title}</div>
                      <div className={index === 5 ? 'value-style last' : 'value-style'}>
                        {item.value}
                      </div>
                    </div>
                  ) : (
                    <Spin />
                  )}
                </div>
              </Card>
            }
          </List.Item>
        </>
      )}
    />
  )
}

export default Overview
